import { SvgIcon, SvgIconProps } from "@mui/material";

export const KeyPointIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 10 10" {...props}>
			<g clip-path="url(#clip0_10271_16438)">
				<path
					d="M4.99488 9.08938C7.25567 9.08938 9.0884 7.25665 9.0884 4.99586C9.0884 2.73507 7.25567 0.902344 4.99488 0.902344C2.7341 0.902344 0.901367 2.73507 0.901367 4.99586C0.901367 7.25665 2.7341 9.08938 4.99488 9.08938Z"
					stroke="#FAFAFA"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M5 6.875C6.03553 6.875 6.875 6.03553 6.875 5C6.875 3.96447 6.03553 3.125 5 3.125C3.96447 3.125 3.125 3.96447 3.125 5C3.125 6.03553 3.96447 6.875 5 6.875Z"
					fill="#FAFAFA"
				/>
			</g>
			<defs>
				<clipPath id="clip0_10271_16438">
					<rect width="9.99109" height="9.99109" fill="white" />
				</clipPath>
			</defs>
		</SvgIcon>
	);
};
